import * as Yup from 'yup';
import { REQUIRED_FIELD_ERROR2 } from '../../utils/constants';

const usePriceValidationSchema = () => {
  const validationSchema = Yup.object()
    .shape({
      base_price: Yup.object().shape({
        high_season_weekday_price: Yup.string().required(REQUIRED_FIELD_ERROR2),
        high_season_weekend_price: Yup.string().required(REQUIRED_FIELD_ERROR2),
        low_season_weekday_price: Yup.string().required(REQUIRED_FIELD_ERROR2),
        low_season_weekend_price: Yup.string().required(REQUIRED_FIELD_ERROR2),
      }),
      isPriceDynamic: Yup.boolean(),
      max_places: Yup.number()
        .required(
          "Заполните максимальное количество мест на вкладке 'Базовые настройки'",
        )
        .min(
          1,
          "Заполните максимальное количество мест на вкладке 'Базовые настройки'",
        ),
      extra_guest_price: Yup.object().shape({
        high_season_weekday_price: Yup.string()
          .default('')
          .when('isPriceDynamic', {
            is: true,
            then: (schema) => schema.required(REQUIRED_FIELD_ERROR2),
            otherwise: (schema) => schema.notRequired(),
          }),
        high_season_weekend_price: Yup.string()
          .default('')
          .test(
            'is-valid-weekend_price',
            REQUIRED_FIELD_ERROR2,
            function (high_season_weekend_price) {
              const isDynamic = this.options.context?.isPriceDynamic;
              if (isDynamic) {
                return isDynamic && high_season_weekend_price;
              }
              return true;
            },
          ),
        low_season_weekday_price: Yup.string()
          .default('')
          .test(
            'is-valid-low_season_weekday_price',
            REQUIRED_FIELD_ERROR2,
            function (low_season_weekday_price) {
              const isDynamic = this.options.context?.isPriceDynamic;
              if (isDynamic) {
                return isDynamic && low_season_weekday_price;
              }
              return true;
            },
          ),
        low_season_weekend_price: Yup.string().test(
          'is-valid-low_season_weekend_price',
          REQUIRED_FIELD_ERROR2,
          function (low_season_weekend_price) {
            const isDynamic = this.options.context?.isPriceDynamic;
            if (isDynamic) {
              return isDynamic && low_season_weekend_price;
            }
            return true;
          },
        ),
        min_guests_weekday: Yup.string()
          .test(
            'is-fill',
            REQUIRED_FIELD_ERROR2,
            function (min_guests_weekday) {
              const isDynamic = this.options.context?.isPriceDynamic;
              if (isDynamic) {
                return isDynamic && min_guests_weekday;
              }
              return true;
            },
          )
          .test(
            'is-valid-min_guests_weekday',
            'Проверьте максимальную вместимость объекта и введите данные по количеству гостей заново',
            function (min_guests_weekday) {
              const max_places = this.options.context?.max_places;
              const isDynamic = this.options.context?.isPriceDynamic;
              if (max_places > 0 && isDynamic) {
                return max_places >= Number(min_guests_weekday);
              }
              return true;
            },
          ),
        min_guests_weekend: Yup.string()
          .test(
            'is-fill',
            REQUIRED_FIELD_ERROR2,
            function (min_guests_weekend) {
              const isDynamic = this.options.context?.isPriceDynamic;
              if (isDynamic) {
                return isDynamic && min_guests_weekend;
              }
              return true;
            },
          )
          .test(
            'is-valid-min_guests_weekend',
            'Проверьте максимальную вместимость объекта и введите данные по количеству гостей заново',
            function (min_guests_weekend) {
              const max_places = this.options.context?.max_places;
              const isDynamic = this.options.context?.isPriceDynamic;
              if (max_places > 0 && isDynamic) {
                return max_places >= Number(min_guests_weekend);
              }
              return true;
            },
          ),
      }),

      start_date_month: Yup.string().required(REQUIRED_FIELD_ERROR2),
      start_date_day: Yup.string().required(REQUIRED_FIELD_ERROR2),
      end_date_month: Yup.string().required(REQUIRED_FIELD_ERROR2),
      end_date_day: Yup.string().required(REQUIRED_FIELD_ERROR2),
      has_kidsPrice: Yup.boolean(),
      ageKidsFree: Yup.string(),
      isAnimalPrice: Yup.boolean().notRequired(),
      animalPrice: Yup.string().when('isAnimalPrice', {
        is: (isAnimalPrice: boolean) => isAnimalPrice === true,
        then: (validationSchema) =>
          validationSchema.required(REQUIRED_FIELD_ERROR2),
        otherwise: (validationSchema) => validationSchema.notRequired(),
      }),
      kidsPrice: Yup.array().of(
        Yup.object().shape({
          start_age: Yup.number().required(REQUIRED_FIELD_ERROR2),
          end_age: Yup.number()
            .transform((value, originalValue) => {
              return originalValue ? Number(originalValue) : null;
            })
            .required(REQUIRED_FIELD_ERROR2)
            .min(1, 'Неверное значение')
            .test('is-kidsAge-valid', 'Неверное значение', function (end_age) {
              const { start_age } = this.parent;
              if (start_age && end_age) {
                return Number(end_age) > Number(start_age);
              }
              return true;
            }),
          price: Yup.object().shape({
            high_season_weekday_price: Yup.string().required(
              REQUIRED_FIELD_ERROR2,
            ),
            low_season_weekend_price: Yup.string().required(
              REQUIRED_FIELD_ERROR2,
            ),
            high_season_weekend_price: Yup.string().required(
              REQUIRED_FIELD_ERROR2,
            ),
            low_season_weekday_price: Yup.string().required(
              REQUIRED_FIELD_ERROR2,
            ),
          }),
        }),
      ),
    })
    .test(
      'fields-not-equal',
      'Нельзя, чтобы все поля были равны',
      function (values) {
        const {
          start_date_month,
          start_date_day,
          end_date_month,
          end_date_day,
        } = values;

        // Проверка, чтобы не все поля были равны
        return (
          start_date_month === end_date_month && start_date_day === end_date_day
        );
      },
    );
  return validationSchema;
};

export default usePriceValidationSchema;
